export default "__VITE_ASSET__C67OEVHm__"